export const naturalCollator = new Intl.Collator("de", {
    sensitivity: "base",
    numeric: true,
});

export function compareNaturalText(left, right) {
    return naturalCollator.compare(left || "", right || "");
}

export function compareByNameThenCode(left, right) {
    const byName = compareNaturalText(left?.name, right?.name);
    if (byName !== 0) return byName;
    return compareNaturalText(left?.code, right?.code);
}

export function sortByNameThenCode(items) {
    return [...(items || [])].sort(compareByNameThenCode);
}
